export enum DamageTypeEnum {
  DPIA = 'DPIA',
  DPIA_SIMPLIFIED = 'DPIA_SIMPLIFIED'
}
